import React, {useState} from 'react';
import {connect} from "react-redux";
import PersonalDetailsForm from '~/Components/Forms/PersonalDetailsForm/PersonalDetailsForm';
import StepsNavigation from '../StepsNavigation';
import {
    updateGuestForm,
    saveGuestPersonalDetails,
    nextStepAction,
} from "~/redux/actions/guests";
import {updateUserAction} from "~/redux/actions/auth";


const PersonalDetails = ({guests, formData, activeGuest, activeStep, ...props}) => {

    const [error, setError] = useState(null);

    const guest = guests[activeGuest];

    const updateForm = (form) => {
        props.dispatch(updateGuestForm(form));
    }

    if (!guest) {
        return <></>;
    }

    const form = formData[activeGuest][activeStep[activeGuest]]

    const handleNext = () => {

        let promise = props.dispatch(saveGuestPersonalDetails(guest.id, form));

        promise.then((data) => {
            if(guest.main) {
                props.dispatch(updateUserAction(form));
            }
            setError(null);
            props.dispatch(nextStepAction());
        }).catch(error => {
            setError(error.data);
        });
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    {error?.message && (
                        <div className="alert alert-danger" role="alert">
                            {error.message}
                        </div>
                    )}

                    <PersonalDetailsForm errors={error?.errors} values={form} onChange={updateForm}/>
                </div>
            </div>

            <StepsNavigation
                fnNext={handleNext}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    guests: state.guests?.list,
    activeGuest: state.guests?.activeGuest,
    activeStep: state.guests?.activeStep,
    formData: state.guests?.formData
});

export default connect(mapStateToProps)(PersonalDetails);
